import { Link } from "@tanstack/react-router";
import { Helmet } from "@/common/components/Helmet";
import { titleTagSuffix } from "@/common/constants";

function PageNotFound() {
  return (
    <>
      <Helmet>
        <title>Page not found{titleTagSuffix}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1>Page not found.</h1>
      <p>
        The page you&rsquo;re looking for doesn&rsquo;t exist or may have moved.
      </p>
      <p>
        <Link to="/app/account/dashboard">Go to your dashboard</Link> or{" "}
        <Link to="/app/resources">browse resources and trainings</Link>.
      </p>
    </>
  );
}

export default PageNotFound;
